import { isNonEmptyString } from './isNonEmptyString';
import { toNumericString } from './toNumericString';

export const toNumberString = (value?: string | number | null): string => {
  const valueAsString = toNumericString(value);

  return isNonEmptyString(valueAsString)
    ? Number(valueAsString).toLocaleString()
    : '';
};
